import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cacheAdminApi } from '../api/cacheAdminApi';

/**
 * DELETE /api/eraf/cache-admin/caches?confirm=EVICT-ALL — 전체 evict (CACHE_EVICT)
 * 성공 시 모든 cache-admin 쿼리 무효화
 */
export function useEvictAll() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => cacheAdminApi.evictAllCaches(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['cache-admin'] });
    },
  });
}
